import React from 'react'
import SbEditable from 'storyblok-react'

import ButtonLink from './../ButtonLink'

import styles from './styles.module.scss'

const LinkItem = (props) => {
    return (
        <SbEditable content={props.blok}>
            <li className={styles['link-item']}>
                <ButtonLink label={props.blok.label} to={props.blok.link.linktype == 'email' ? props.blok.link.email : props.blok.link.cached_url} />
            </li>
        </SbEditable>
    )
}

export default LinkItem
